module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "home-body"
  }, [_vm._c('div', {
    staticClass: "wrap-black banner-with-copy"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-6 pic"
  }, [_vm._c('picture', {
    attrs: {
      "title": ""
    }
  }, [_vm._c('source', {
    attrs: {
      "srcset": "/static/img/features/banner1_800.jpg",
      "media": "(min-width: 501px) and (max-width: 800px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/features/banner1_800.jpg",
      "media": "(min-width: 801px) and (max-width: 1200px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/features/banner1_800.jpg",
      "media": "(min-width: 1201px) and (max-width: 1600px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/features/banner1_1000.jpg",
      "media": "(min-width: 1601px)"
    }
  }), _vm._v(" "), _vm._c('img', {
    attrs: {
      "src": "/static/img/features/banner1_800.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "overlay"
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-6  banner-content-wrap"
  }, [_vm._c('div', {
    staticClass: "banner-copy"
  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            What really sets us apart is our most outstanding feature. CLEX starts users off with easier study content which progressively gets more challenging.\n            This increased challenge uniquely matches the learning speed of each individual, maximizing their learning potential.\n          ")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign Up for Free")])], 1)])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "features-row"
  }, [_vm._c('div', {
    staticClass: "container ptb-100"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._c('AdBlock', {
    staticClass: "hidden-sm hidden-xs",
    attrs: {
      "slot-id": 2,
      "count": 1
    }
  })], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._c('div', {
    staticClass: "features-row"
  }, [_vm._c('div', {
    staticClass: "container ptb-100"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._c('AdBlock', {
    staticClass: "hidden-sm hidden-xs",
    attrs: {
      "slot-id": 2,
      "count": 1
    }
  })], 1)]), _vm._v(" "), _vm._m(6)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('h1', [_vm._v("CLEX "), _vm._c('br'), _vm._v("Features")])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "row feature xs-mb-50"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 pic text-center"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/features/Features_Icons-01.svg",
      "alt": "Use micro notes to help you focus on your studies"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 xs-pt-30"
  }, [_vm._c('h2', [_vm._v("\n            Micro notes\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("Use micro notes to help you focus on your studies.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "row feature"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-push-6 pic text-center"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/features/Features_Icons-02.svg",
      "alt": "Build word banks to help you improve your memorization skills"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-pull-6 xs-pt-30"
  }, [_vm._c('h2', [_vm._v("\n            Word banks\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("Build word banks to help you improve your memorization skills.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "bg-slide text-center features-col"
  }, [_vm._c('div', {
    staticClass: "container ptb-100"
  }, [_vm._c('div', {
    staticClass: "row xs-mb-50 xs-pb-50"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-6 xs-mb-50 md-mb-0 pic"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/features/Features_Icons-03.svg",
      "alt": "Challenge Yourself"
    }
  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Challenge Yourself\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("Set your own study challenge levels for "), _vm._c('br'), _vm._v("each lecture note.")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-6 pic"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/features/Features_Icons-04.svg",
      "alt": "Shared Learning"
    }
  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Shared learning\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("Share learning notes with your"), _vm._c('br'), _vm._v(" class mates.")])])]), _vm._v(" "), _vm._c('a', {
    staticClass: "btn-pub btn-pub-primary video-btn fixed-width xs-full-width",
    attrs: {
      "href": "https://vimeo.com/204826626",
      "target": "_blank"
    }
  }, [_vm._v("Watch Our Video")])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "row feature xs-mb-50"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 pic text-center"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/features/Features_Icons-05.svg",
      "alt": "Schedule Studying"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6  xs-pt-30"
  }, [_vm._c('h2', [_vm._v("\n            Schedule Studying\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("Set your own testing dates to match your study schedule.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "row feature"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-push-6 pic text-center"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/features/Features_Icons-06.svg",
      "alt": "Study Anywhere"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-pull-6 xs-pt-30"
  }, [_vm._c('h2', [_vm._v("\n            Study Anywhere\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("Test your knowledge at your own pace on any device at any time.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "wrap-black text-center features-col"
  }, [_vm._c('div', {
    staticClass: "container"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-6 xs-mb-50 md-mb-0 pic"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/features/Features_Icons-07.svg",
      "alt": "Secure Studying"
    }
  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Secure Studying\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("Create your own secure personal"), _vm._c('br'), _vm._v(" student account.")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-6 pic"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/features/Features_Icons-08.svg",
      "alt": "Cloud Storage"
    }
  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Cloud Storage\n          ")]), _vm._v(" "), _vm._c('p', {
    staticClass: "large-text"
  }, [_vm._v("Store all your study notes in one"), _vm._c('br'), _vm._v(" secure location.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53cef9da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/home/FeaturesPage.vue
// module id = 666
// module chunks = 1